/*
 * Icon block constants
 */

/**
 * View options enum for icon block
 *
 * @enum VIEWS
 * @type {{DEFAULT: string, STACKED: string, FRAMED: string}}
 */
export const VIEWS = {
  DEFAULT: 'default',
  STACKED: 'stacked',
  FRAMED: 'framed',
};

/**
 * Shape options enum for icon block
 *
 * @enum SHAPES
 * @type {{CIRCLE: string, SQUARE: string}}
 */
export const SHAPES = {
  CIRCLE: 'circle',
  SQUARE: 'square',
};
